import React, { useState, useEffect, useContext } from 'react'
import UserContext from '../context/UserContext'
import { useNavigate } from 'react-router-dom'

import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import './ReportCalendar.css'

import { API, graphqlOperation } from 'aws-amplify'
import { listFccReports } from "../graphql/queries"

import { sortByDate } from "../util/modelUtil"


const ReportCalendar = (props) => {
  const navigate = useNavigate()
  const [reportList, setReportList] = useState([])
  const [datesToHighlight, setDatesToHighlight] = useState([])

  // Function to highlight dates in calendar
  const reportDatesHighlight = ({ date, view }) => {
    if (view === 'month' && datesToHighlight.find(dDate => isSameDay(dDate, date))) {
      return 'react-calendar__tile--hasActive'  // react-calendar class
    }  else {
      return 'react-calendar__tile--inactive'; // Non-selectable class
    }
  }

  // Helper function to check if two dates are the same
  const isSameDay = (d1, d2) => {
    return d1.getUTCFullYear() === d2.getUTCFullYear() &&
      d1.getUTCMonth() === d2.getUTCMonth() &&
      d1.getUTCDate() === d2.getUTCDate()
  }

  const fetchReports = async () => {   
    try {
      const res = await API.graphql(graphqlOperation(listFccReports, {
        filter: {
          publishedAt: {gt: '0000-00-00T00:00:00Z'}, // filter out unpublished reports
        },
        limit: 1000,
      }))

      let items = res.data.listFccReports.items
      items = items.filter((record) => record._deleted !== true)
      items = items.filter((record) => record.publishedAt !== null)
      items = sortByDate(items, 'reportDate')
      setReportList(items)

      // extract publishedAt dates from reports
      setDatesToHighlight(items.map(report => new Date(report.reportDate)))

    } catch (error) {
      console.error('Error fetching reports:', error);
    }
  }
  
  useEffect(() => {
    fetchReports()
  }, [])

  const getReportIdByDate = (reports, clickedDate) => {
    const formattedClickedDate = clickedDate.toISOString().split('T')[0]
    for (const report of reports) {
      if (report.publishedAt) {
        const reportDate = report.publishedAt.split('T')[0]
        if (reportDate === formattedClickedDate) {
          return report.id
        }
      }
    }
    return ''
  }

  const calendarClickHandler = (value) => {
    const reportId = getReportIdByDate(reportList, value)
    if (reportId) {
      navigate(`/home/daily/${reportId}`)
    }
  }


  return (
    <Calendar 
      calendarType="gregory" 
      tileClassName={reportDatesHighlight} 
      onClickDay={calendarClickHandler} 
    />
  )
}

export default ReportCalendar